var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilters = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.75 4.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 6.75h2.458a2.5 2.5 0 0 0 4.584 0H15v-1.5H8.2a2.5 2.5 0 0 0-4.9 0H1zM10.25 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 10.25h-2.364a2.501 2.501 0 0 0-4.772 0H1v1.5h6.864a2.501 2.501 0 0 0 4.772 0H15z",
    clipRule: "evenodd"
  })));
};
export default SvgFilters;